import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpClient,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpUserEvent
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import {
  catchError,
  switchMap,
  finalize,
  filter,
  take,
  map
} from 'rxjs/operators';
import { TokenResponse } from './tokenResponse';
import { LogService } from '../logging/log.service';
import { TokenService } from './token.service';

@Injectable()
export class AuthResponseInterceptor implements HttpInterceptor {
  currentRequest: HttpRequest<any>;
  isRefreshingToken = false;
  tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>("");

  constructor(
    private router: Router,
   // this might be causing circular reference.
   //private httpClient: HttpClient,
    private tokenService: TokenService,
    private logger: LogService
  ) {


  }

  // see: http://ericsmasal.com/2018/07/02/angular-6-with-jwt-and-refresh-tokens-and-a-little-rxjs-6/
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // this.auth = this.injector.get(AuthService);
    //var token = (this.auth.isLoggedInSubject.value) ? this.auth.getAuth()!.token : null;
    
    console.log("AuthResponseInterceptor");        
    console.log(request);        
    
    if(request.url.includes("AWSAccessKeyId"))
    {
      console.log("AWSAccessKeyId");
      return next.handle(request);
    }

    const token = this.tokenService.getToken();

    // is this correct? not in:
    // http://ericsmasal.com/2018/07/02/angular-6-with-jwt-and-refresh-tokens-and-a-little-rxjs-6/
    
    /*
    if (!token) {
      this.logger.info("token not truthy");
      return next.handle(request);
    }
*/
this.logger.info("adding token to request");

  const clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });



    this.logger.info("calling next.handle");


return next.handle(clonedRequest).pipe(
  catchError((error: HttpErrorResponse) => {
  

    // Check if it's a 401 Unauthorized error
    if (error.status === 401) {
      // Handle the 401 response (e.g., logout, redirect to login page, etc.)
      this.tokenService.clearTokenResponse(); // Log the user out
      this.router.navigate(['/login']); // Redirect to the login page
    }

    throw error; // Re-throw the error after handling
  })
);

}
/*
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

    this.logger.info("in handle401Error");

    if (!this.isRefreshingToken) {
      this.isRefreshingToken = true;

      // Reset here so that the following requests wait until the token
      // comes back from the refreshToken call.
      this.tokenSubject.next("");

      //return this.httpClient.get
      return this.tokenService.refreshToken().pipe(
        switchMap((tokenResponse: TokenResponse) => {
          if (tokenResponse.succeeded) {
            //this.tokenService.setTokenData(tokenResponse.token);
            this.logger.info("Back from refresh token");
            const token = this.tokenService.getToken() ?? "";
           
            if(this.tokenService.getToken() !== tokenResponse.token)
            {
              this.logger.error("Tokens don't match! old/new");
              this.logger.error(token);
              this.logger.error(tokenResponse.token);

            }
           
            this.tokenSubject.next(token);
            return next.handle(this.addTokenToRequest(request, token));
          }

          this.logger.info('tokenResponse.succeeded was false');
          return this.router.navigate(['/login']);
        }),
        catchError(err => {
          this.logger.error("handle401Error caught error");
          this.logger.error(err);
          this.isRefreshingToken = false;
          return this.handleError(err, next);
        }),
        finalize(() => {
          this.logger.info("finalize from refresh token");
          this.isRefreshingToken = false;
        })
      );
    } else {
      this.isRefreshingToken = false;

      return this.tokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => {
          return next.handle(this.addTokenToRequest(request, token));
        })
      );
    }
  }

   // private handleError(err: any, next: HttpHandler): Observable<HttpEvent<any>> {
    private handleError(err: any, next: HttpHandler): any {
      
    if (err instanceof HttpErrorResponse) {
      if (err.status === 404 || err.status === 401 || err.status === 403 ) {
        console.log('Token not found. redirect to login...');
        return this.router.navigate(['/login']);
      }
      
      this.logger.error(err.error);
 
      throw err;
    }
    return next;
  }
*/
}
